import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
import App from './containers/App/App';
import store from './store';
import './index.css';
import 'react-md/dist/react-md.indigo-pink.min.css';


import WebFontLoader from 'webfontloader';
WebFontLoader.load({
    google: {
      families: ['Roboto:300,400,500,700', 'Material Icons']
    }
  });


ReactDOM.render((
<Provider store={store}>
<HashRouter>
    <App />
</HashRouter>
</Provider>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js